import Enterprise from '@/datatypes/enterprise';

export default class Promocode {
  public id: string;
  public code: string;
  public usedAt: string;
  public enterprise: Enterprise;

  constructor(options) {
    this.id = options.id;
    this.code = options.code;
    this.usedAt = options.usedAt;
    if (options.enterprise) {
      this.enterprise = options.enterprise;
    } else {
      this.enterprise = new Enterprise({});
    }
  }
}
